import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  AddProgressBarWorkflowStack,
  RemoveAllProgressBarWorkflowStack,
  RemoveProgressBarWorkflowStack,
} from '../actions/progress-bar-workflow.action';

export interface ProgressBarStateWorkflowModel {
  items: Array<{ uniqueId: string }>;
}

@State<ProgressBarStateWorkflowModel>({
  name: 'progressBarWorkflowItems',
  defaults: {
    items: [],
  },
})
@Injectable()
export class ProgressBarWorkflowState {
  @Selector()
  static getProgressBarWorkflowStack(state: ProgressBarStateWorkflowModel) {
    return state.items;
  }

  @Action(AddProgressBarWorkflowStack)
  addProgressBarWorkflowStack(
    ctx: StateContext<ProgressBarStateWorkflowModel>,
    action: AddProgressBarWorkflowStack,
  ) {
    /* get the old value from state */
    const currentState = ctx.getState().items;

    /* check the existing value with new object */
    const isExist = currentState.some((item) => item.uniqueId === action.payload.uniqueId);

    /* if it is there then return the function. */
    if (isExist) {
      return;
    }

    /* update the state */
    ctx.patchState({
      items: [...currentState, action.payload],
    });
  }

  @Action(RemoveProgressBarWorkflowStack)
  removeProgressBarWorkflowStack(
    ctx: StateContext<ProgressBarStateWorkflowModel>,
    action: RemoveProgressBarWorkflowStack,
  ) {
    let currentState = ctx.getState().items;

    /* filter out state's data without action's object*/
    currentState = currentState.filter((item) => item.uniqueId !== action.payload.uniqueId);

    /* update the state */
    ctx.patchState({
      items: [...currentState],
    });
  }

  @Action(RemoveAllProgressBarWorkflowStack)
  removeAllProgressBarWorkflowStack(ctx: StateContext<ProgressBarStateWorkflowModel>) {
    /* update the state */
    ctx.patchState({
      items: [],
    });
  }
}
